const password_restore = {
    title: String("Password recovery"),
    newPasswordAsk: String("Enter the new password."),
    changePasswordButton: String("Change Password"),
    passwordChanged: String("The password has been changed correctly."),
    emailNotFound: String("Email does not exist, please introduce a valid email."),
    keyError: String("There is some problem with the password recovery link. Click on the email button or return to fill the form 'forgot your password?'."),
};

export default password_restore;